import SubscriptionUi from '@/app/subscription-ui/SubscriptionUi.vue';
import { ConfigurationFactory } from '@/app/subscription-ui/configuration.factory';
import { SubscriptionControllerPlugin } from '@/app/subscription-ui/subscription-controller.plugin';
import { TranslationPlugin } from '@/plugins/translation.plugin';
import { createApp } from 'vue'

const configurationFactory = new ConfigurationFactory();
const instance = createApp(SubscriptionUi);

instance.use(new TranslationPlugin(configurationFactory.getTranslationConfiguration()));
instance.use(new SubscriptionControllerPlugin(configurationFactory));
instance.mount('#subscription-ui');
